export default __webpack_public_path__ + "static/media/download.41926ce4.svg";